module.exports = __webpack_public_path__ + "img/medical.cb7f45b5.svg";